"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Lists_1 = require("./Lists");
exports.default = Lists_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Lists/index.js
// module id = 1781
// module chunks = 8